import { CLICK, component, demoFile, story } from "system/demo";
import { QuestionCards } from 'feature/topic/question-cards';

demoFile('feature/topic/question-cards');

component('QuestionCards', QuestionCards, {
    state: {
        collections: {
            relatedConversations: [{key: 'a', name: 'My Question', deleted: false}]
        },
        embeddedInstanceData: {
            question: {
                a: {
                    globals: {name: 'My Question'},
                    collections: {comment: [
                        {key: 1, from: 'a', text: 'This is a comment in an embedded instance'},
                    ]}
                }
            }
        }
    }
}, [
    story('Show more', [
        CLICK('Show more')
    ])
]); 